import React from "react";
import { Header, Image } from "semantic-ui-react";

const PagarPrestamosHeader = () => {
  return (
    <>
      <Header as="h1" color="blue">
        <Image src="/assets/icons/pago.svg" size="big" /> Realiza tus pagos
      </Header>
    </>
  );
};

export default PagarPrestamosHeader;
